import { useMutation } from "@tanstack/vue-query";
import { useApi } from "./useApi";
import { useToaster } from "./useToaster";

interface UploadMultipleParams {
  files: File[];
  collection: string;
  metadata?: Record<string, unknown>;
}

interface ApiError {
  response?: {
    status?: number;
    data?: {
      message?: string;
    };
  };
}

export function useMediaUploadMultipleMutation() {
  const api = useApi();
  const toaster = useToaster();

  return useMutation({
    mutationFn: async (params: UploadMultipleParams) => {
      return await api.media.uploadMultiple(params);
    },
    retry: (failureCount, error) => {
      const apiError = error as ApiError;
      
      if (apiError?.response?.status === 422) {
        return false;
      }
      if (!apiError?.response) {
        return failureCount < 3;
      }
      if (apiError?.response?.status === 429) {
        return failureCount < 2;
      }
      
      return false;
    },
    retryDelay: (attemptIndex) => {
      return Math.min(1000 * Math.pow(2, attemptIndex), 30000);
    },
    onError: (error) => {
      const apiError = error as ApiError;
      let message = "Upload failed after multiple attempts";
      
      if (apiError?.response?.status === 422) {
        message = apiError.response?.data?.message || "File validation failed";
      } else if (apiError?.response?.status === 429) {
        message = "Too many upload attempts. Please wait a moment and try again.";
      } else if (!apiError?.response) {
        message = "Upload failed. Please check your connection.";
      } else if (apiError?.response?.data?.message) {
        message = apiError.response.data.message;
      }
      
      toaster.create({
        title: message,
        type: "error",
      });
    },
  });
}



